export class DictionaryTypes {
    public static readonly DictionaryTypeSelectAll = 'ca43829e-ea88-41b6-8e23-4ee19fb318bf';
}